'use client';

import { useEffect } from 'react';

import NextError from 'next/error';

import { useDevErrorReset } from '@/hooks/use-dev-error-reset';
import { captureExceptionToPostHog } from '@/lib/utils/posthog-client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureExceptionToPostHog(error);
  }, [error]);

  useDevErrorReset(reset);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
